function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import DotsIcon from '../svgs/components/dots';
import { GALLERY_CONSTS } from 'pro-gallery-lib';

var Dots = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Dots, _React$Component);

  function Dots(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onKeyPress = _this.onKeyPress.bind(_assertThisInitialized(_this));
    _this.onDotsClick = _this.onDotsClick.bind(_assertThisInitialized(_this));
    _this.getClickAction = _this.getClickAction.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Dots.prototype;

  _proto.onDotsClick = function onDotsClick(e) {
    e.stopPropagation();
    e.preventDefault();
    this.props.onDotsClick && this.props.onDotsClick();
  };

  _proto.onKeyPress = function onKeyPress(e) {
    switch (e.keyCode || e.charCode) {
      case 32: // space

      case 13:
        // enter
        e.preventDefault();
        e.stopPropagation();
        this.onDotsClick(e);
        return false;

      default:
        break;
    }
  };

  _proto.getClickAction = function getClickAction() {
    if (this.props.viewMode === GALLERY_CONSTS.viewMode.SITE || this.props.viewMode === GALLERY_CONSTS.viewMode.SEO) {
      var action = this.onDotsClick;
      return this.props.isMobile ? {
        onTouchEnd: action
      } : {
        onClick: action
      };
    } else {
      return {
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      };
    }
  };

  _proto.render = function render() {
    var clickAction = this.getClickAction();
    var DotsIconElement = /*#__PURE__*/React.createElement(DotsIcon, _extends({}, clickAction, {
      size: "20"
    }));

    if (this.props.dotsWrapper) {
      DotsIconElement = this.props.dotsWrapper(_objectSpread({
        dotsElement: DotsIconElement
      }, this.props));
    }

    return /*#__PURE__*/React.createElement("div", {
      className: 'info-member info-element-social-button info-element-social-dots',
      "data-hook": "item-dots",
      "aria-label": "Dots",
      role: "button",
      tabIndex: -1
    }, DotsIconElement);
  };

  return Dots;
}(React.Component);

export default Dots;